import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";
import { useIslandHost } from "@frontend/contexts";

import { LoginForm } from "./LoginForm";
import {
  type LoginFormDataProps,
  loginFormDataSchema,
} from "./LoginForm.schema";
import type { AuthenticatedUser } from "./types";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "login-form": {
      props: LoginFormDataProps;
      handle: undefined;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-login-form": HTMLElement;
  }
}

export function RWCLoginForm({
  username,
  redirectTo,
}: LoginFormDataProps): JSX.Element {
  const host = useIslandHost();

  function emit(type: string, detail: Record<string, unknown> = {}) {
    host?.dispatchEvent(new CustomEvent(type, { detail, bubbles: true }));
  }

  function onSignedIn(user: AuthenticatedUser) {
    emit("login:signed-in", { user });

    if (redirectTo) {
      window.location.assign(redirectTo);
    }
  }

  return (
    <LoginForm
      username={username}
      onSignedIn={onSignedIn}
      onSignedOut={() => emit("login:signed-out")}
    />
  );
}

componentManager.register(
  rwc("login-form", {
    component: RWCLoginForm,
    dataSchema: loginFormDataSchema,
  }),
);
